// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__oXd0R","col":"CardReaderDesc_col__1kSMG","label":"CardReaderDesc_label__1GA8y"};